import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=130d5462&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=130d5462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d5462",
  null
  
)

export default component.exports